
const GREY1 = '#666666';
const GREY2 = '#aaaaaa';
const GREY3 = '#cccccc';
const GREY4 = '#f9f9f9';

const ORANGE = '#fa7754';
const PINK = '#f8748c';
const PURPLE = '#ad98eb';
const GREEN = '#62bf61';
const RED = '#da394a';
const YELLOW = '#ffcb4b';
const BLUE = '#88C9EE';

export const COLORS_NAME = [
  'ORANGE',
  'PINK',
  'PURPLE',
  'GREEN',
  'RED',
  'YELLOW',
  'BLUE',
  'GREY1',
  'GREY2',
  'GREY3',
  'GREY4',
];

export const COLORS = {
  ORANGE,
  PINK,
  PURPLE,
  GREEN,
  RED,
  YELLOW,
  BLUE,
  GREY1,
  GREY2,
  GREY3,
  GREY4,
};